import { useLocation } from "wouter";
import { erpMenuForPath, hasOnlyMenuGrantAccess } from "@eurostorm/shared";
import { useAuth } from "./useAuth.js";

/**
 * F-roles — true quando o usuário pode ESCREVER (criar/editar/importar/modificar).
 *
 * Modelo de nível global: super admin sempre pode; admin/user podem; viewer
 * (Visualizador) NÃO. O backend já bloqueia mutations e uploads para viewer —
 * este hook serve para a UI esconder/desabilitar os controles de escrita e
 * evitar que o visualizador clique em algo que daria erro de permissão.
 *
 * F-acesso-por-menu (CEO 2026-10-12): usuário de portal com menus liberados
 * pode escrever na tela cujo menu está em nível `operate` (o servidor aplica
 * a mesma regra, procedure a procedure).
 */
export function useCanEdit(): boolean {
  const { user } = useAuth();
  const [location] = useLocation();
  if (!user) return false;
  if (user.isSuperAdmin) return true;
  if (hasOnlyMenuGrantAccess(user)) {
    const menu = erpMenuForPath(location);
    return menu != null && user.menuGrants.some((g) => g.menu === menu && g.level === "operate");
  }
  return user.memberships.some((m) => m.active && (m.role === "user" || m.role === "admin"));
}

/** Conveniência: o inverso de useCanEdit (é visualizador / somente leitura). */
export function useIsReadOnly(): boolean {
  return !useCanEdit();
}
